import { render, staticRenderFns } from "./CustomPrescriptionVS.vue?vue&type=template&id=53a2e2c6&scoped=true&"
import script from "./CustomPrescriptionVS.vue?vue&type=script&lang=js&"
export * from "./CustomPrescriptionVS.vue?vue&type=script&lang=js&"
import style0 from "./CustomPrescriptionVS.vue?vue&type=style&index=0&id=53a2e2c6&scoped=true&lang=css&"
import style1 from "./CustomPrescriptionVS.vue?vue&type=style&index=1&id=53a2e2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2e2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a2e2c6')) {
      api.createRecord('53a2e2c6', component.options)
    } else {
      api.reload('53a2e2c6', component.options)
    }
    module.hot.accept("./CustomPrescriptionVS.vue?vue&type=template&id=53a2e2c6&scoped=true&", function () {
      api.rerender('53a2e2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Prescription/CustomPrescriptionVS.vue"
export default component.exports